import { useEffect } from "react";
import { draft, useAnyDraftDirty } from "../../hooks/draft";
import { useDataStateSelector } from "../../hooks/useData";
import { useMainContext } from "../../hooks/useMainContext";
import { warnsOnUnload } from "../../hooks/navigationGuard";
import ConflictDialog from "./conflictDialog";

// Once for the app: the conflict dialog, the notification of a refused
// operation (no draft on main), and the browser's warning when the page is
// closed or reloaded with unsaved work: a draft not saved, or the form being
// edited with changes (unsavedData). The browser's Back and Forward are
// guarded by NavigationGuard.
export default function DraftHost() {
  const draftDirty = useAnyDraftDirty();
  const formDirty = useDataStateSelector((state) => Boolean(state.unsavedData));
  const warns = warnsOnUnload({ draftDirty, formDirty });
  const { createNotification } = useMainContext();

  useEffect(
    () =>
      draft.subscribeRefused((message) =>
        createNotification("error", message)
      ),
    [createNotification]
  );

  useEffect(() => {
    if (!warns) return;

    const warn = (event) => {
      event.preventDefault();
      event.returnValue = "";
    };

    window.addEventListener("beforeunload", warn);
    return () => window.removeEventListener("beforeunload", warn);
  }, [warns]);

  return <ConflictDialog />;
}
